// src/config/config.js
export const COMPETITION_END_DATE = new Date('2025-01-01T00:00:00Z');  // Update this to the desired competition end date
export const WINNERS_ANNOUNCEMENT_DATE = new Date('2026-03-16T00:00:00');  // Winners announcement date
export const clientId = "Ad0kUljEBhZWnOdffPsI57z0bSGIyfqb7T64QEvj-2yvkjdFKpiIlUeatZDGZ7LNNSzzfdHqKcqcFi3L";
export const paymentValue = 1.0;
export const breif_doc_name = "Design With Curves Competition Brief- 2025- Morphologic" 
